import { createFileRoute } from '@tanstack/react-router'

import { OperationalWorkspace } from '#components/features/operations/operational-workspace'
import { ComandaScreen } from '#components/features/orders/comanda-screen'
import { useOperationalWorkspaceMode } from '#hooks/use-operational-workspace-mode'
import { requireOperationalWorkspace } from '#utils/operational-route'

export const Route = createFileRoute('/comanda/$id')({
  beforeLoad: async ({ context, params }) => {
    await requireOperationalWorkspace(context.queryClient)
    context.queryClient.removeQueries({ queryKey: ['comanda', params.id] })
  },
  head: () => ({
    meta: [
      { title: 'Comanda | UseComanda' },
      {
        name: 'description',
        content: 'Consulte itens, pedidos e fechamento da comanda.',
      },
    ],
  }),
  validateSearch: (search: Record<string, unknown>) => ({
    tab:
      search.tab === 'cart'
        ? ('cart' as const)
        : search.tab === 'bill'
          ? ('bill' as const)
          : ('menu' as const),
  }),
  component: ComandaPage,
})

function ComandaPage() {
  const { id } = Route.useParams()
  const { tab } = Route.useSearch()
  const mode = useOperationalWorkspaceMode()

  return (
    <OperationalWorkspace>
      <ComandaScreen tableId={id} initialTab={tab} variant={mode} />
    </OperationalWorkspace>
  )
}
